<nav class="navbar navbar-expand-lg navbar-light bg-white position-fixed top-0 start-0 w-100 py-3 z-3 epf-navbar">
  <div class="container-fluid d-flex align-items-center">

    <!-- LEFT: logo (uses your brand-logo class from CSS) -->
    <a href="#" class="navbar-brand brand-logo m-0" aria-label="Home"></a>

    <button
      class="navbar-toggler ms-auto"
      type="button"
      aria-controls="epf_navbar"
      :aria-expanded="is_nav_open ? 'true' : 'false'"
      aria-label="Toggle navigation"
      @click="toggle_nav"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div
      class="collapse navbar-collapse text-xs"
      id="epf_navbar"
      :class="{ show: is_nav_open }"
    >
      <ul class="navbar-nav mx-lg-auto mb-2 mb-lg-0 text-uppercase fw-semibold">
        <li class="nav-item"><a class="nav-link nav-underline px-lg-3" href="#ProblemSection" @click="close_nav">The Crisis</a></li>
        <li class="nav-item"><a class="nav-link nav-underline px-lg-3" href="#ImpactEcosystemSection" @click="close_nav">How It Works</a></li>
        <li class="nav-item"><a class="nav-link nav-underline px-lg-3" href="#SustainableSocialImpactNote" @click="close_nav">The SSIN</a></li>
        <li class="nav-item"><a class="nav-link nav-underline px-lg-3" href="#ChooseYourLegacySection" @click="close_nav">Assets</a></li>
        <li class="nav-item"><a class="nav-link nav-underline px-lg-3" href="#GovernanceLockSection" @click="close_nav">Governance</a></li>
      </ul>

      <router-link
        to="/login"
        class="btn btn-primary btn-sm text-xs text-uppercase fw-light px-4 py-2 rounded-3 epf-cta"
      >
        Adopt an Asset
      </router-link>

    </div>

  </div>
</nav>
